import { useQuery } from "@tanstack/react-query";

import { modelQuery } from "#modules/models/infra/model.query";

export const useMyModel = () => {
  const { data, ...rest } = useQuery({ ...modelQuery() });

  return { model: data, ...rest };
};
